<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <h1 class="my-0">Discounts</h1>
      <v-btn color="primary" @click="$router.push({ name: 'website.discount.code.create' })">+ Create discount</v-btn>
    </div>
    <Notification v-if="error" :messages="error" type="error" />
    <v-card class="pt-0" rounded="lg">
      <HeaderTableTabs :currentTab.sync="currentTab" :tabs="tabs" />
      <Resource
        :document="document"
        :filter-fields="null"
        :filter-data="filterData"
        :filter-callback="setFilterData"
        :searchable="searchableField"
        :columns="columns"
        :update-router-callback="getUpdateRouterData"
        :callback-action="getAction"
        :actionItems="items"
        :routeName="updateRouteName"
        class="mx-3"
      />
      <div class="d-flex align-center justify-space-between pl-3 py-4">
        <limit-page :callback="setLimit" />
        <pagination
          :visible="0"
          v-if="!$parent.isLoading && document"
          :length="lengthPage"
          :page.sync="page"
        ></pagination>
      </div>
    </v-card>
    <delete-action :content="ids.length + ' discounts?'" title="Delete discounts" />
  </div>
</template>

<script>
import { discountService } from '@/apis/discount';
import datetime from '@/helpers/datetime';
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      showDialogDelete: false,
      ids: [],
      error: null,
      isLoading: false,
      datetime,
      items: [{ title: 'Delete discounts', action: 'delete' }],
      tabs: [
        { name: 'All', key: '' },
        { name: 'Active', key: 'active' },
        { name: 'Scheduled', key: 'scheduled' },
        { name: 'Expired', key: 'expired' },
      ],
      resourceType: 'discount',
      columns: {
        Selectable: {
          blankLabel: true,
          kind: 'selectable',
          width: 1,
        },
        Code: {
          field: 'discount_code',
          kind: 'view',
        },
        Status: {
          field: 'discount_status',
          kind: 'status',
        },
        Start: {
          field: 'discount_start_date',
          kind: 'date',
          type: 'utc',
        },
        End: {
          field: 'discount_end_date',
          kind: 'date',
          type: 'utc',
        },
      },
      updateRouteName: 'website.discount.code.update',
      searchableField: 'title_search',
      sortable: [],
    };
  },
  created() {},
  methods: {
    async submitDelete() {
      try {
        let params = {
          ids: this.ids,
        };
        let data = await discountService.deleteByIds(this.ids);

        await this.getResources();
      } catch (error) {}
      this.showDialogDelete = false;
    },
    getAction(action, ids) {
      if (action.action == 'delete') {
        this.showDialogDelete = true;
        this.ids = ids;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
